'use client';
/* eslint-disable react/jsx-no-useless-fragment */
import { SelectedMenus, Template } from '@zeus/shared';
import { forwardRef, memo } from 'react';
import Category from '../category';
import { isBetweenRange } from '../../../../../utils/utils';
import Template3Logo from '../../Logo';

interface TemplateMenu {
  menu: SelectedMenus;
  template: Template;
  development?: boolean;
  menuIndex: number;
  timezone?: string;
  scale?: number;
  tenantId?: number;
  active?: boolean;
  shouldLoad?: boolean;
}

const Menu = forwardRef<HTMLDivElement, TemplateMenu>(
  ({ menu, template, development, timezone, scale = 1, tenantId, active, shouldLoad = true }, ref) => {
    const isDevelopment = development ? true : isBetweenRange(menu.schedules, timezone);
    const media = template?.media?.mediaContent;
    const isMedia = template?.media?.isEnabled && media?.url;
    const isBrandLogo = !!(template?.brandLogo && template?.brandLogo?.isEnabled && template?.brandLogo?.image);
    const isLayout1Media = isMedia && template.layoutType === 1;
    const isLayout2Media = isMedia && template.layoutType === 2;
    const fontFamily = template?.fontFamilyName;

    return (
      <>
        {isDevelopment && (
          <>
            {menu.categories.slice(0, 3).map((category, categoryIndex) => {
              const newIndex = isLayout1Media && category.index !== 0 ? Number(category?.index) + 1 : category.index;
              return (
                <section
                  key={category.id}
                  id={String(newIndex)}
                  style={{
                    width: newIndex === 1 ? '36%' : '32%',
                    order: newIndex,
                    ...(newIndex === 1 ? { display: 'flex', flexDirection: 'column' } : {}),
                    ...(isLayout2Media && newIndex === 1 ? { height: '100%' } : {}),
                  }}
                >
                  {newIndex === 1 && isBrandLogo && (
                    <Template3Logo scale={scale} url={template.brandLogo?.image as string} />
                  )}
                  <Category
                    key={`${category.id}`}
                    category={category}
                    template={template}
                    categoryIndex={newIndex}
                    development={development}
                    timezone={timezone}
                    scale={scale}
                    tenantId={tenantId}
                    fontFamily={fontFamily}
                    active={active}
                    shouldLoad={shouldLoad}
                  />
                </section>
              );
            })}
          </>
        )}
      </>
    );
  }
);

export default memo(Menu);
